// TODO 所有公众号家长端相关页面路由在此配置
// TODO 所有路由的path必须以 /makefriend/ 开头
// TODO 所有路由的name以及webpackChunkName必须以 makefriend 开头

export default [
  {
    path: '/makefriend',
    name: 'makeFriend',
    component: () => import(/* webpackChunkName: "makeFriend" */ '@/views/makefriend/index.vue'),
    meta: {
      title: '添加老师微信'
    }
  },
  {
    path: '/makefriend/add',
    name: 'makeFriendAdd',
    component: () => import(/* webpackChunkName: "makeFriendAdd" */ '@/views/makefriend/add.vue'),
    meta: {
      title: '添加老师微信'
    }
  }
]
